import { Rating } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

const HorizontalProductCard = ({ product, key, ...props }) => {
  const currencySymbols = {
    EUR: "€",
    USD: "$",
    AED: "AED",
  };

  return (
    <Link
      to={`/product-single/${product.slug}`}
      className="horizontal-product-item mb-0 product-card-link"
    >
      <div className="product-image">
        <img src={product.proimg?.[0]?.src} alt={"image - " + product.proimg?.[0]?._id} />
      </div>
      <div className="product-info">
        <span className="product-card-title">{product.title}</span>
        <div className="flex items-center gap-10 p-0 m-0">
          <Rating size="small" name="read-only" precision={0.5} value={+product?.five_start_rating} readOnly
            sx={{
              "& .MuiRating-iconFilled": { color: "#f4b419" },
              "& .MuiRating-iconEmpty": { color: "#c4c4c4" },
            }}
          />{" "}
          <span style={{ fontSize: "10px" }}>{product?.five_start_rating || 0} star rating</span>
        </div>
        <div className="price pt-1">
          <span className="present-price">
            {currencySymbols[localStorage.getItem("currency")] ? currencySymbols[localStorage.getItem("currency")] + " " : "AED"}
            {product.price}
          </span>
        </div>
      </div>
    </Link>
  );
};

export default HorizontalProductCard;
